import { LineItem } from "../../interfaces/LineItem";

export const reportLineItemsWithAllocatedMarkups = (lineItems: LineItem[]): LineItem[] => {
  return lineItems.map((item) => {
    if (!item.markup_allocation) return item;
    const total = Number(item.total) || 0;
    if (total === 0) return item;
    const markupFactor = item.total_plus_markup / total;
    const cloned: LineItem = { ...item, total: item.total_plus_markup };
    Object.keys(cloned).forEach((key) => {
      if (
        // Individual Rate scales with Crew Rate, so the two keep the same ratio once markups are in.
        (key.endsWith("_$") ||
          key.endsWith("_$$") ||
          key.endsWith("_uc") ||
          key === "labor_rate" ||
          key === "individual_rate") &&
        cloned[key] != null
      ) {
        cloned[key] = cloned[key] * markupFactor;
      }
    });
    return cloned;
  });
};
